import React from 'react';
import PropTypes from 'prop-types';
import { HeadingSection } from '../design-system/Headings';
import Paragraph from '../design-system/Paragraph';
import Container from '../design-system/Containers';
import DashboardButton from '../pages/Dashboard/DashboardButton';

export default function DossierPromo({
  title,
  description,
  buttonText,
  buttonLink,
  locked,
  onButtonUnlockedClick,
  onButtonLockedClick,
}) {
  return (
    <Container bgGradDown px0>
      <div className="ss_dossier-promo__cluster">
        <span className="ss_dossier-promo__cluster--left" />
        <span className="ss_dossier-promo__cluster--right" />
        <div className="ss_dossier-promo__content ss_px--sm">
          <HeadingSection el="h2" center py0 my0>
            {title}
          </HeadingSection>
          <Paragraph center myMd>
            {description}
          </Paragraph>
          <Container center py0 my0>
            <DashboardButton
              onClickUnlocked={onButtonUnlockedClick}
              onClickLocked={onButtonLockedClick}
              locked={locked}
              href={buttonLink}
              secondary
              my0
            >
              {buttonText}
            </DashboardButton>
          </Container>
        </div>
      </div>
    </Container>
  );
}

DossierPromo.propTypes = {
  locked: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  buttonText: PropTypes.string.isRequired,
  buttonLink: PropTypes.string.isRequired,
  onButtonLockedClick: PropTypes.func.isRequired,
  onButtonUnlockedClick: PropTypes.func.isRequired,
};
